import { withServiceImplementation } from '@myaccount/utils';

import IDeposit from './DepositInterface';

export default withServiceImplementation(IDeposit, {});